import { ReactComponent as IcLoading } from '@/assets/icons/ic_loading.svg';


interface CircularLoadingProps {
    colorClass?: string
  }

export const CircularLoading: React.FC<CircularLoadingProps> = ({colorClass}) => 
  <IcLoading className={`text-${colorClass || 'inherit'} animate-spin h-5 w-5`}/>